<template>
  <div>
    <v-list>
      <!-- DASHBOARD -->
      <!-- <v-tooltip right>
        <v-list-tile :to="{path: '/dashboard'}" ripple slot="activator" :class="{'list__tile--active-router' : '/dashboard' == $route.matched[1].path}">
          <v-list-tile-action>
            <v-icon :class="{'secondary--text' : '/dashboard' == $route.matched[1].path}">dashboard</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <span>{{ $t('dashboard') | cap }}</span>
      </v-tooltip> -->
      <!-- TRAFIC -->
      <v-tooltip right v-if="checkPermission('ALL_ACCESS')">
        <v-list-tile 
          :to="pathTrafic"
          ripple
          slot="activator"
          :class="{'list__tile--active-router' : '/trafic' == $route.matched[1].path}">
          <v-list-tile-action>
            <v-badge
              right
              color="accent"
              v-model="$store.state._StoreWatcheeBox.listeAllVisiteurs.length"
            >
              <span class="caption" slot="badge">
                {{ nbVisitors }}
              </span>
              <v-icon :class="{'primary--text' : '/trafic' == $route.matched[1].path}">explore</v-icon>
            </v-badge>
          </v-list-tile-action>
        </v-list-tile>
        <span>
          {{ $t('trafic') | cap }} {{ '(' + $tc('visitors', $store.state._StoreWatcheeBox.listeAllVisiteurs.length, { count: nbVisitors }) + ')' }}
        </span>
      </v-tooltip>
      <!-- STATISTIQUES -->
      <v-tooltip right v-if="checkPermission('NO_PEONS')">
        <v-list-tile
          :to="{path: '/stats/audience'}"
          ripple
          slot="activator"
          :class="{'list__tile--active-router' : '/stats' == $route.matched[1].path}"
        >
          <v-list-tile-action>
            <v-icon :class="{'primary--text' : '/stats' == $route.matched[1].path}">assessment</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <span>{{ $t('stats') | cap }}</span>
      </v-tooltip>
      <!-- GESTION DES COMPTES (management) -->
      <v-tooltip right v-if="checkPermission('NO_PEONS_NOR_AGENTS')">
        <v-list-tile
          :to="{path: '/management/agents'}"
          ripple
          slot="activator"
          :class="{'list__tile--active-router' : '/management' == $route.matched[1].path}"
        >
          <v-list-tile-action>
            <v-icon :class="{'primary--text' : '/management' == $route.matched[1].path}">assignment_ind</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <span>{{ $t('management') | cap }}</span>
      </v-tooltip>

      <!-- MEDIA -->
      <v-tooltip right v-if="checkPermission('NO_PEONS_NOR_AGENTS')">
        <v-list-tile
          :to="pathMedia"
          ripple
          slot="activator"
          :class="{'list__tile--active-router' : '/media' == $route.matched[1].path}"
        >
          <v-list-tile-action>
            <v-icon :class="{'primary--text' : '/media' == $route.matched[1].path}">perm_media</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <span>{{ $t('media') | cap }}</span>
      </v-tooltip>

      <!-- BOT BUILDER -->
      <v-tooltip right v-if="checkPermission('NO_PEONS_NOR_AGENTS')">
        <v-list-tile
          :to="(this.$store.state._User.bots.length !== 0 && this.$store.state._User.bots[0].USR_ID !== 0)? {path: '/botbuilder/openAIConfig'} : {path: '/botbuilder/openAIConfig'}"
          ripple
          slot="activator"
          :class="{'list__tile--active-router' : '/botbuilder' == $route.matched[1].path}"
        >
          <v-list-tile-action>
            <v-icon :class="{'primary--text' : '/botbuilder' == $route.matched[1].path}">psychology</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <span>Bot Builder</span>
      </v-tooltip>

      <!-- PARAMÈTRES -->
      <v-tooltip right v-if="checkPermission('NO_PEONS')">
        <v-list-tile
          :to="{path: '/settings/preview'}"
          ripple
          slot="activator"
          :class="{'list__tile--active-router' : '/settings' == $route.matched[1].path}"
        >
          <v-list-tile-action>
            <v-icon :class="{'primary--text' : '/settings' == $route.matched[1].path}">settings</v-icon>
          </v-list-tile-action>
        </v-list-tile>     
        <span>{{ $t('settings') | cap }}</span>
      </v-tooltip>
      
      <!-- TICKETING -->
      <!--
      <v-tooltip right v-if="brideMenu('ticketing') === '1' && !isMobile">
        <v-list-tile
          :to="{path: '/ticketing/freshdesk'}"
          ripple
          slot="activator"
          :class="{'list__tile--active-router' : '/ticketing' == $route.matched[1].path}"
        >
          <v-list-tile-action>
            <v-icon :class="{'secondary--text' : '/ticketing' == $route.matched[1].path}">receipt</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <span>Ticketing</span>
      </v-tooltip>
      -->

    </v-list>
  </div>
</template>

<script>
// import { LEVEL } from '../../constants'
import permission from '../../mixins/permissions'
import { mapState } from 'vuex'
export default {
  mixins: [permission],
  name: 'WzMenu',
  created () {
    console.log('menu :: ', this.$route.matched[1].path)
  },
  computed: {
    ...mapState('_User', ['hideTabVisitors', 'brides']),
    nbVisitors () {
      return this.$store.state._StoreWatcheeBox.listeAllVisiteurs.length > 99
        ? '99+'
        : this.$store.state._StoreWatcheeBox.listeAllVisiteurs.length
    },
    pathTrafic () {
      let pathTrafic = {path: '/trafic/visitors'}
      if (!this.checkPermission('NO_ADMINS')) {
        // l'admin à uniquement le droit au monitoring dans trafic
        pathTrafic = {path: '/trafic/monitoring'}
      } else {
        // si la nav du haut n'est pas affiché c'est la ,page chatting par defaut
        if (this.hideTabVisitors) {
          pathTrafic = {path: '/trafic/chatting'}
        } else {
          // si le trafic visiteur n'est pas bridé
          // console.log(this.brideMenu('trafic_visiteurs'))
          if (Number(this.brideMenu('trafic_visiteurs'))) {
            // console.log('--> go to page visiteurs', self.location.href)
            // console.log('this.$route.params.id', this.$route.params.id)
            pathTrafic = {path: '/trafic/visitors'}
          // sinon on test la page suivante
          } else if (Number(this.brideMenu('trafic_discussions'))) {
            // console.log('page chat')
            pathTrafic = {path: '/trafic/chatting'}
          }
        }
      }
      return pathTrafic
    },
    pathMedia () {
      let pathMedia = {path: '/media/biblios'}
      // si la nav du haut n'est pas affiché c'est la ,page chatting par defaut
      if (Number(this.brideMenu('media_phrases'))) {
        pathMedia = {path: '/media/biblios'}
      } else {
        if (Number(this.brideMenu('media_push'))) {
          pathMedia = {path: '/media/pushs'}
        } else {
          if (Number(this.brideMenu('media_faq'))) {
            pathMedia = {path: '/media/faq'}
          }
        }
      }
      return pathMedia
    }
  },

  methods: {
    // pour tester mais pas utilisé
    brideMenu (nameBride) {
      // console.log('brideMenu===================================================================', this.brides)
      if (this.brides) {
        let index = this.brides.findIndex(bride => bride.brideName === nameBride)
        // console.log('index', index)
        if (index !== -1) {
          return this.brides[index].status
        }
      }
    }
  }
}
</script>

<style>
  /**
   * Mettre en évidence la route sur laquelle on se trouve
   */
  li.list__tile--active-router {
    background-color: rgba(0, 0, 0, 0.12);
  }
</style>




// WEBPACK FOOTER //
// src/components/watcheezy/WzMenu.vue